import { useAppDispatch, useAppSelector } from '@/shared/infra/store/hooks';
import { setCustomDocumentTypes } from './customDocumentTypeSlice';
import CustomDocumentType from '../../application/domain/entities/CustomDocumentType';

export const useReduxCustomDocumentTypeAdapter = () => {
  const dispatch = useAppDispatch();
  const { customDocumentTypes } = useAppSelector(
    (state) => state.customDocumentTypes
  );

  return {
    getCustomDocumentTypes: () => {
      return customDocumentTypes;
    },
    setCustomDocumentTypes: async (
      customDocumentTypes: Array<CustomDocumentType>
    ) => {
      dispatch(setCustomDocumentTypes(customDocumentTypes));
    },
  };
};
